import React, { useEffect } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { Column } from '@cards/Card';
import CallToActionDetailsCard from '@cards/CallToAction/Details';
import { setCurrentScreen, screens } from '../../analytics';
import './style.less';

function CallToAction() {
  const match = useRouteMatch();
  const {
    params: { id: appUserId, ctaId },
  } = match;

  useEffect(() => {
    setCurrentScreen(screens.APP_USER_CALL_TO_ACTION);
  }, []);

  return (
    <Column className="call-to-action">
      <CallToActionDetailsCard appUserId={appUserId} ctaId={ctaId} />
    </Column>
  );
}

export default CallToAction;
